import Observer from '@/common/scripts/observer';
import {Utils} from '@/common/scripts/utils';

const observer = new Observer();

class Menu {
    constructor(element) {
        this.element = element || document.querySelector('.j-menu');
        this.content = this.element.querySelector('.j-menu__content');
        this.contentGrid = this.content.querySelector('.j-menu__content-grid');

        this.openClass = 'is-open';
        this.closeClass = 'is-close';
        this.isOpen = false;

        this._bindContext();
        this._subscribe();
        this._bindEvents();
    }

    /**
     * Привязывает контекст
     * @private
     */
    _bindContext() {
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    /**
     * Подписывается на события других модулей
     * @private
     */
    _subscribe() {
        // Когда нажали открыть меню
        observer.subscribe('menu:openTrigger', this.open);

        // Когда нажали на якорь
        observer.subscribe('scrollByStart', this.close);

        // Когда нажали закрыть меню
        observer.subscribe('menu:closeTrigger', this.close);
    }

    /**
     * Отслеживает события
     * @private
     */
    _bindEvents() {
        document.addEventListener('keyup', (element) => {
            this._closeByKeyboard(element);
        });
    }

    /**
     * Закрывает меню по нажатию на ESC
     * @param {Object} key - объект события
     */
    _closeByKeyboard(key) {
        const keyCodeESC = 27;

        if (key.keyCode === keyCodeESC) {
            this.close();
        }
    }

    /**
     * Открывает меню
     */
    open() {
        this.isOpen = true;
        this.element.classList.add(this.openClass);
        this.element.classList.remove(this.closeClass);
        // this.element.style.top = `${window.scrollY}px`;
        this.contentGrid.scrollTo(0, 0);
        Utils.bodyFixed(this.contentGrid);
        observer.publish('menu:open');
    }

    /**
     * Закрывает меню
     */
    close() {
        if (!this.isOpen) {
            return;
        }

        this.isOpen = false;
        this.element.classList.remove(this.openClass);
        this.element.classList.add(this.closeClass);
        Utils.bodyStatic();
        observer.publish('menu:close');
    }
}

export default Menu;
